@if(component){
<div class="wrap">
    <text-box [textAlign]="'left'"
              [data]="component" />
    @for (row of component.rows; track $index) {
    <div class="flex flex-column-s flex-column-m _row"
         [class]="($first ? 'm-t-7' : 'm-t') + ' ' + (row.variant === 'columns-reverse' ? 'flex-reverse flex-column-reverse-s flex-column-reverse-m' : '')">
        <a class="b-a b-col-5 _row-item w-12-s w-12-m"
           [class]="row.variant === 'fullWidth' ? 'w-12' : 'w-7'"
           [routerLink]="row.link"
           (mouseenter)="mouseEnterHandler($event)"
           (mouseleave)="mouseLeaveHandler($event)">
            <df-image-wrapper>
                <img [ratio]="row.variant === 'fullWidth' ? '4/1' : client.sizeId < 2 ? '3/2' : ''"
                     [dfImage]="row.image">
            </df-image-wrapper>
            <div class="p-a col-1 center"
                 [class]="row.backgroundColor">
                <p class="h3 h4-s h4-m"
                   *iCms="'title' of row"></p>
                <span class="m-t-2"
                      [buttonStyle]="'text-button'">
                    <span *iCms="'buttonLabel' of row"></span>
                </span>
            </div>
        </a>
        @if(row.variant !== 'fullWidth') {
        <a class="w-5 w-12-s w-12-m b-a b-col-5 flex flex-column _row-item"
           [routerLink]="row.link2"
           (mouseenter)="mouseEnterHandler($event)"
           (mouseleave)="mouseLeaveHandler($event)">
            <df-image-wrapper class="w-12 height-100 pos-relative ratio-10-9-s ratio-10-9-m">
                <img [fill]="true"
                     [dfImage]="row.image2">
            </df-image-wrapper>
            <div class="p-a col-1 center"
                 [class]="row.backgroundColor">
                <p class="h3 h4-s h4-m"
                   *iCms="'title2' of row"></p>
                <span class="m-t-2"
                      [buttonStyle]="'text-button'">
                    <span *iCms="'buttonLabel2' of row"></span>
                </span>
            </div>
        </a>
        }
    </div>
    }
</div>
}